import * as React from 'react';
import { Editable, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminInstitutionGroupAllEventsAddCoHostRequest } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType } from 'gossamer-unified';

export interface AllEventsAddCoHostButtonProps {
  institutionGroupId: number;
}

export const AllEventsAddCoHostButton: React.FC<AllEventsAddCoHostButtonProps> = (props) => {
  const [emailAddress, setEmailAddress] = React.useState<string | undefined>(undefined);
  const handleClick = async () => {
    if (!emailAddress) return;
    try {
      const response = await fetchApi('POST', `/main/institution-group-all-events-add-co-host`, {
        emailAddress: emailAddress,
        institutionGroupId: props.institutionGroupId,
      } as AdminInstitutionGroupAllEventsAddCoHostRequest);
      notifyResponse(response);
      setEmailAddress(undefined);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the co-host for all events in the group');
    }
  };

  return (
    <InputGroup>
      <InputGroup.Text>Add a co-host for all events in this Group</InputGroup.Text>
      <Editable
        handleChange={setEmailAddress}
        value={emailAddress}
        field={{
          seq: 0,
          type: FieldType.Text,
          label: 'Email Address',
        }}
      />
      <Button size="sm" variant="primary" disabled={!emailAddress} onClick={handleClick}>
        Add Co-Host
      </Button>
    </InputGroup>
  );
};
